import React from "react";
import { Link, NavLink } from "react-router-dom";
import { Grid3x3, Moon, Sun, Database, LogIn, LayoutDashboard } from "lucide-react";
import useTheme from "../../hooks/useTheme";
import useAuth from "../../hooks/useAuth";

export default function AppBar({ version, updatedAt }) {
  const { theme, toggle } = useTheme();
  const auth = useAuth();
  const user = auth?.user;
  const updated = updatedAt ? new Date(updatedAt) : null;
  const updatedLabel =
    updated && !Number.isNaN(updated.getTime())
      ? updated.toLocaleDateString(undefined, { year: "numeric", month: "short", day: "numeric" })
      : "";
  return (
    <header className="appbar">
      <div className="appbar-inner">
        <Link to="/" className="brand" data-testid="brand-link">
          <span className="brand-mark">
            <Grid3x3 size={18} strokeWidth={2.4} aria-hidden="true" />
          </span>
          <span className="brand-text">
            Microsoft <b>License Hub</b>
          </span>
        </Link>
        <nav className="appbar-nav" aria-label="Primary">
          <NavLink to="/" end data-testid="nav-matrix">
            Matrix
          </NavLink>
          <NavLink to="/admin" data-testid="nav-admin">
            Admin
          </NavLink>
        </nav>
        <div className="appbar-right">
          {user ? (
            <Link to="/app" className="tb-btn sm workspace-link" data-testid="nav-workspace">
              <LayoutDashboard size={14} /> Workspace
            </Link>
          ) : (
            <Link to="/login" className="tb-btn sm workspace-link" data-testid="nav-signin">
              <LogIn size={14} /> Sign in
            </Link>
          )}
          {version && (
            <span className="chip mono" title={updatedLabel ? `Dataset updated ${updatedLabel}` : "Dataset version"} data-testid="dataset-chip">
              <Database size={12} aria-hidden="true" /> v{version}
            </span>
          )}
          <button
            type="button"
            className="icon-btn"
            onClick={toggle}
            aria-label={theme === "dark" ? "Switch to light theme" : "Switch to dark theme"}
            title={theme === "dark" ? "Light theme" : "Dark theme"}
            data-testid="theme-toggle"
          >
            {theme === "dark" ? <Sun size={16} aria-hidden="true" /> : <Moon size={16} aria-hidden="true" />}
          </button>
        </div>
      </div>
    </header>
  );
}
